import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchCategoriesIfNeeded, getSubCategories, excludeDeprecated
  } from 'common/ducks/categories';
import { fetchIndustriesIfNeeded } from 'common/ducks/industry';
import { PORTFOLIO_FORM } from 'profile/constants';
import FormEntryInfoComponent from 'profile/components/portfolio/form_entry_info';

const WrappedForm = reduxForm({
  form: PORTFOLIO_FORM,
})(FormEntryInfoComponent);

WrappedForm.need = [fetchCategoriesIfNeeded];

const mapStateToProps = (state) => {
  /* filter out deprecated and 1-1 (sub)categories */
  const categories = excludeDeprecated(state.categories.data).filter(cat => !cat.is_one_to_one);

  let initialFormValues = null;
  const revision = state.profile.portfolio.portfolioForm.revision;

  if (revision) {
    initialFormValues = {
      portfolio_title: revision.title,
      portfolio_description: revision.description,
      portfolio_subcategory: revision.sub_category,
      portfolio_industry: revision.industry
    };
  }

  return {
    subCategories: getSubCategories({ data: categories }),
    industries: state.industry.data,
    initialValues: initialFormValues,
  };
};

export default connect(mapStateToProps, {
  fetchCategoriesIfNeeded,
  fetchIndustriesIfNeeded
})(WrappedForm);



// WEBPACK FOOTER //
// ./profile/containers/portfolio/form_entry_info.js